import {Injectable} from '@angular/core';
import {BaseApiService} from '../../shared/base-service/base-api.service';

@Injectable()
export class CustomerDetailService extends BaseApiService {
    getData(customerId: string) {
        return this.get('Customer/' + customerId);
    }
    getCustomerOrganization(customerId: number) {
        return this.get('Customer/CustomerOrganization/' + customerId);
    }
    updateCustomerOrganization(data: any) {
        return this.post('Customer/CustomerOrganization/', data);
    }
    public checkForCustomerAndCreateAppointment(customerNumberId: string, firstName: string, lastName: string) {
        return this.get('Foundation/BusinessTransaction/Appointment/CreateCustomer/' + customerNumberId + '/' + firstName + '/' + lastName);
    }
    public checkForOrgCustomerAndCreateAppointment(customerNumberId: string, orgName: string) {
        return this.get('Foundation/BusinessTransaction/Appointment/CreateCustomer/' + customerNumberId + '/' + orgName);
    }
}
